var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.648 13.982c.156.072.321-.085.226-.215-.52-.708-.784-2.05 0-3.583C4.18 7.628 4.806 7.271 4.806 7.271s-.217.955.93 2.328c1.103 1.322 2.289 2.76 1.315 4.146-.091.13.07.283.225.214 1.205-.54 2.557-1.622 2.71-3.775.056-.658-.029-1.58-.45-2.742-.543-1.473-1.21-2.16-1.595-2.456-.115-.088-.295-.01-.285.124.112 1.59-.571 1.993-.96 1.084-.156-.363-.246-.991-.246-1.756A5.517 5.517 0 0 0 5.097.788a4.461 4.461 0 0 0-.85-.756c-.118-.08-.289 0-.278.13.071.864.007 3.338-2.474 6.293C-.755 9.197.117 11.303.427 11.873a4.776 4.776 0 0 0 2.221 2.109Z",
    fill: "#A29271",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeat2);
export default __webpack_public_path__ + "static/media/iconHeat2.2b380e096207bd56537a40fd2c6776e4.svg";
export { ForwardRef as ReactComponent };